import { issueInvoicePageViewList } from "pages/IssueInvoice/utils";

export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const FIELD_EXTRA = {
  FIELD_EMPTY: {
    field: "FIELD_EMPTY",
  },
};

export const ISSUE_INVOICE_COMMON_FIELD = {
  NOTE: {
    field: "note", // ghi chú
    type: "text",
    required: false,
  },
  PBAN: {
    field: "pban", // Phiên Bản
    type: "text",
    max: 6,
    disabled: true,
    isHide: true,
    required: false,
  },
  TTCHUNG_KHHDON: {
    xs: 2,
    field: "ttchung_khhdon", // Ký hiệu hóa đơn
    type: "text",
    // isKHHD: true,
    max: 6,
    required: false,
    disabled: true,
    order: 1,
    styleInput: {
      borderBottom: "none",
      //   marginLeft: "-27px",
      paddingLeft: "0px",
    },
  },
  TTCHUNG_HTTTOAN: {
    field: "ttchung_htttoan", // Hình thức thanh toán
    type: "select",
    max: 50,
    required: true,
    order: 2,
    isClearable: true,
  },
  TTCHUNG_KHMSHDON: {
    field: "ttchung_khmshdon", // Ký hiệu mẫu số hóa đơn
    type: "text",
    isShowLabel: false,
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
      TICKETS_INVOICE: "5",
      DELIVERY_BILL: "6",
      WAREHOUSE_AGENCY: "6",
    },
    max: 1,
    required: false,
    disabled: true,
    order: 5,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
    },
  },
  TTCHUNG_MHSO: {
    field: "ttchung_mhso", // Mã hồ sơ
    type: "text",
    max: 20,
    required: false,
    order: 5,
  },
  TTCHUNG_SHDON: {
    xs: 2,
    field: "ttchung_shdon", // Số hóa đơn
    type: "text",
    required: false,
    disabled: true,
    order: 5,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
      color: "red",
    },
  },
  TTCHUNG_SBKE: {
    field: "ttchung_sbke", // Số bảng kê
    type: "text",
    max: 20,
    required: false,
    order: 5,
  },
  TTCHUNG_NLAP: {
    xs: 4,
    field: "ttchung_nlap", // Ngày lập
    type: "date",
    required: true,
    disabled: false,
    marginLeft: "-27px",
    order: 5,
    styleInput: {
      marginLeft: "-37px",
    },
  },
  TTCHUNG_NBKE: {
    field: "ttchung_nbke", // Ngày bảng kê
    type: "date",
    required: false,
    order: 5,
  },
  TTCHUNG_DVTTE: {
    field: "ttchung_dvtte", // Đơn vị tiền tệ
    type: "select",
    max: 3,
    required: true,
    order: 5,
  },
  TTCHUNG_TGIA: {
    field: "ttchung_tgia", // Tỷ giá
    type: "number",
    max: 7,
    disabled: false,
    required: false,
    order: 5,
  },
  TTCHUNG_THDON: {
    field: "ttchung_thdon", // Tên Hóa Đơn
    type: "text",
    isHide: false,
    disabled: true,
    max: 100,
    required: false,
    order: 1,
    isShowLabel: false,
    xs: 4,
    styleInput: {
      borderBottom: "none",
      fontWeight: "500",
      fontSize: "20px",
      marginLeft: "-9px",
    },
  },
  TTCHUNG_MSTTCGP: {
    field: "ttchung_msttcgp", // Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử
    type: "text",
    isHide: true,
    max: 14,
    required: false,
    order: 5,
  },
  TTCHUNG_MSTDVNUNLHDON: {
    field: "ttchung_mstdvnunlhdon", // Mã số thuế đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 14,
    isHide: true,
    required: false,
    order: 5,
  },
  TTCHUNG_TDVNUNLHDON: {
    field: "ttchung_tdvnunlhdon", // Tên đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 400,
    required: false,
    isHide: true,
    order: 5,
  },
  TTCHUNG_DCDVNUNLHDON: {
    field: "ttchung_dcdvnunlhdon", // Địa chỉ đơn vị nhận ủy nhiệm lập hóa đơn
    type: "text",
    max: 400,
    isHide: true,
    required: false,
    order: 5,
  },
  TTCHUNG_HDDCKPTQUAN: {
    // chỉ với HD BH,
    field: "ttchung_hddckptquan", // Hoá đơn dành cho khu phi thuế quan
    type: "select",
    isHide: true,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE,
    ],
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
    },
    max: 1,
    required: false,
    order: 5,
    widthLabel: "108px",
  },
  TTChung_TTKhac: {
    field: "ttchung_ttkhac", // Thông tin chung khác
    type: "object",
    max: 255,
    isHide: true,
    required: false,
  },
};

export const ISSUE_INVOICE_SELLER_FIELD = {
  NBAN_TEN: {
    xs: 6,
    field: "nban_ten", // Tên
    type: "text",
    max: 400,
    disabled: true,
    required: false,
    isShowLabel: false,
    styleInput: {
      borderBottom: "none",
      fontWeight: "bold",
      fontSize: "15px",
      marginLeft: "-9px",
    },
  },
  NBAN_MST: {
    xs: 6,
    field: "nban_mst", // Mã số thuế
    type: "text",
    isTaxCode: false,
    max: 14,
    disabled: true,
    required: true,
    isHideRequiredIcon: true,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
      fontWeight: "600",
      letterSpacing: "1px",
    },
  },
  NBAN_DCHI: {
    field: "nban_dchi", // Địa chỉ
    type: "text",
    max: 400,
    disabled: true,
    required: false,
    styleInput: {
      borderBottom: "none",
      marginLeft: "-27px",
    },
  },
  NBAN_SDTHOAI: {
    field: "nban_sdthoai", // Số điện thoại
    type: "text",
    disabled: true,
    required: false,
    max: 20,
  },
  NBAN_DCTDTU: {
    field: "nban_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    max: 50,
    disabled: true,
    required: false,
  },
  NBAN_STKNHANG: {
    field: "nban_stknhang", // Số tài khoản ngân hàng
    type: "select",
    max: 30,
    disabled: false,
    required: false,
    allowCreate: true,
  },
  NBAN_TNHANG: {
    field: "nban_tnhang", // Tên ngân hàng
    type: "text",
    max: 400,
    disabled: false,
    required: false,
  },
  NBAN_FAX: {
    field: "nban_fax", // Fax
    type: "text",
    max: 20,
    disabled: true,
    required: false,
  },
  NBAN_WEBSITE: {
    field: "nban_website", // Website
    type: "text",
    max: 100,
    disabled: true,
    required: false,
  },
  NBAN_TTKHAC: {
    field: "nban_ttkhac", // Thông tin khác
    type: "text",
    isHide: true,
    max: 255,
    disabled: true,
    required: false,
  },
};

export const ISSUE_INVOICE_BUYER_FIELD = {
  NMUA_TEN: {
    field: "nmua_ten", // Tên người mua hàng
    type: "text",
    max: 400,
    required: true,
    xs: 8,
  },
  NMUA_MST: {
    field: "nmua_mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
  },
  NMUA_DCHI: {
    field: "nmua_dchi", // Địa chỉ
    type: "text",
    max: 400,
    xs: 8,
  },
  NMUA_MKHANG: {
    field: "nmua_mkhang", // Mã khách hàng
    type: "select",
    max: 50,
  },
  NMUA_SDTHOAI: {
    field: "nmua_sdthoai", // Số điện thoại
    type: "text",
    max: 20,
    xs: 4,
  },
  NMUA_DCTDTU: {
    field: "nmua_dctdtu", // Địa chỉ thư điện tử
    type: "text",
    isEmail: true,
    max: 50,
    xs: 3,
  },

  NMUA_HVTNMHANG: {
    field: "nmua_hvtnmhang", // Họ và tên người mua hàng
    type: "text",
    max: 100,
  },
  SEND_MAIL: {
    field: "send_mail", // Địa chỉ thư điện tử
    type: "checkbox",
    isEmail: true,
    max: 50,
    xs: 1,
  },
  NMUA_STKNHANG: {
    field: "nmua_stknhang", // Số tài khoản ngân hàng
    type: "select",
    max: 30,
    allowCreate: true,
  },
  NMUA_TNHANG: {
    field: "nmua_tnhang", // Tên ngân hàng
    type: "text",
    max: 400,
  },
  NMUA_MDVQHNSACH: {
    field: "nmua_mdvqhnsach", // Mã đơn vị quan hệ ngân sách
    type: "text",
    max: 7,
  },
  NMUA_CCCDAN: {
    field: "nmua_cccdan", // Căn cước công dân
    type: "text",
    max: 12,
  },
  NMUA_SHCHIEU: {
    field: "nmua_shchieu", // Số hộ chiếu
    type: "text",
    max: 20,
  },
  NMua_TTKhac: {
    field: "nmua_ttkhac", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};

// Danh sách hàng hóa dịch vụ
export const ISSUE_INVOICE_HHDV_FIELD = {
  HHDV_OBJ: {
    field: "hhdv_obj",
    type: "field_array",
    require: true,
    fieldReal: "listInvoiceDetail",
    list: {
      TCHAT: {
        field: "tchat", // Tính chất
        fieldReal: "tchat",
        type: "select",
        selectValues: {
          GOODS: "1", // hàng hóa dịch vụ
          PROMOTION: "2", // khuyến mãi
          DISCOUNT: "3", // chiết khấu thương mại
          EXPLAIN: "4", // Ghi chú diễn giải
          SPECIALIZATION_GOODS: "5", // Hàng hóa đặc trưng
        },
        max: 1,
        width: "300px",
        required: true,
      },
      STT: {
        field: "stt", // Số thứ tự
        fieldReal: "stt",
        type: "number",
        isHide: true,
        required: false,
        max: 4,
      },
      MHHDVU: {
        field: "mhhdvu", // Mã hàng hóa, dịch vụ
        fieldReal: "mhhdvu",
        type: "text",
        max: 50,
        width: "200px",
        isHide: true,
        allowCreate: true,
        required: false,
      },
      THHDVU: {
        field: "thhdvu", // Tên hàng hóa, dịch vụ, diễn giải
        fieldReal: "thhdvu",
        // type: "text",
        max: 500,
        width: "400px",
        type: "text",
        allowCreate: true,
        required: true,
      },
      TTHHDTRUNG: {
        field: "tthhdtrung", // Tên hàng hóa, dịch vụ, diễn giải
        fieldReal: "tthhdtrung",
        type: "modalLHHDTrung",
        // required: true,
        list: {
          LHHDTrung: {
            field: "LHHDTrung", // Loại hàng hóa đặc trưng
            fieldReal: "LHHDTrung",
            type: "select",
            options: [
              {
                value: 1,
                label: "Xe ô tô, xe mô tô",
                data: [
                  {
                    label: "Số khung",
                    value: "SKhung",
                  },
                  {
                    label: "Số máy",
                    value: "SMay",
                  },
                ],
              },
              {
                value: 2,
                label: "Dịch vụ vận chuyển",
                data: [
                  {
                    label: "Biển kiểm soát phươn tiện vận chuyển",
                    value: "BKSPTVChuyen",
                  },
                ],
              },
              {
                value: 3,
                label: "Dịch vụ vận chuyển trên nền tảng số, TMĐT",
                data: [
                  {
                    label: "Tên người gửi hàng",
                    value: "TNGHang",
                  },
                  {
                    label: "Địa chỉ người gửi hàng",
                    value: "DCNGHang",
                  },
                  {
                    label: "MST người gửi hàng",
                    value: "MSTNGHang",
                  },
                  {
                    label: "Số định danh người gửi hàng",
                    value: "MDDNGHang",
                  },
                ],
              },
            ],
            required: true,
          },
          TTruong: {
            field: "TTruong", // Tên trường
            fieldReal: "TTruong",
            type: "select",
            required: true,
          },
          DLieu: {
            field: "DLieu", // Dữ liệu trường
            fieldReal: "DLieu",
            type: "text",
            required: true,
          },
        },
      },
      DVTINH: {
        field: "dvtinh", // Đơn vị tính
        fieldReal: "dvtinh",
        isHideWhenAdjustChangeInfo: true,
        type: "text",
        max: 50,
        width: "150px",
        required: false,
      },
      SLUONG: {
        field: "sluong", // Số lượng
        fieldReal: "sluong",
        isHideWhenAdjustChangeInfo: true,
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      DGIA: {
        field: "dgia", // Đơn giá
        fieldReal: "dgia",
        isHideWhenAdjustChangeInfo: true,
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      TLCKHAU: {
        field: "tlckhau", // Tỷ lệ % chiết khấu
        fieldReal: "tlckhau",
        isHideWhenAdjustChangeInfo: true,
        type: "number",
        isThousandSeparator: true,
        width: "200px",
        maxValue: 100,
        required: false,
      },
      STCKHAU: {
        field: "stckhau", // Số tiền chiết khấu
        fieldReal: "stckhau",
        isHideWhenAdjustChangeInfo: true,
        type: "number",
        isThousandSeparator: true,
        width: "200px",
        max: 21,
        required: false,
      },
      TSUAT: {
        field: "tsuat", // Thuế suất
        fieldReal: "tsuat",
        isHideWhenAdjustChangeInfo: true,
        type: "select",
        width: "200px",
        allowCreate: true,
        isShowWithPageView: [
          issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
          issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
          issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
          issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
        ],
        max: 11,
        required: false,
      },
      THTIEN: {
        field: "thtien", // Thành tiền
        fieldReal: "thtien",
        width: "300px",
        isHideWhenAdjustChangeInfo: true,
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        required: false,
      },
      TTKHAC: {
        field: "ttkhac", // Thông tin khác
        fieldReal: "ttkhac",
        type: "text",
        isHide: true,
        required: false,
        max: 255,
      },
    },
  },
};

export const ISSUE_INVOICE_PAYMENT_FIELD = {
  TTOAN_LTSUAT_OBJ: {
    field: "ttoan_ltsuat_obj",
    fieldReal: "ttoan_ltsuat",
    type: "field_array",
    list: {
      TSUAT: {
        field: "ttoan_tsuat", // Thuế suất thuế GTGT
        fieldReal: "TSuat",
        type: "select",
        width: "200px",
        max: 11,
        disabled: true,
        allowNegative: true,
        required: false,
      },
      THTIEN: {
        field: "ttoan_thtien", // Thành tiền chưa có thuế GTGT
        fieldReal: "ThTien",
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        allowNegative: true,
        required: false,
      },
      TTHUE: {
        field: "ttoan_tthue", // Tiền thuế GTGT
        fieldReal: "TThue",
        type: "number",
        isThousandSeparator: true,
        allowNegative: true,
        disabled: false,
        required: false,
        max: 21,
      },
    },
  },
  TTOAN_TGTCTHUE: {
    field: "ttoan_tgtcthue", // Tổng tiền chưa thuế
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    max: 21,
    widthLabel: "fit-content",
    disabled: true,
    required: false,
    isHide: false,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
    ],
    styleInput: {
      width: "350px",
    },
  },
  TTOAN_TGTTHUE: {
    field: "ttoan_tgtthue", // Tổng tiền thuế
    type: "number",
    allowNegative: true,
    max: 21,
    isThousandSeparator: true,
    isHide: false,
    isShowWithPageView: [
      issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
    ],
    disabled: true,
    widthLabel: "fit-content",
    required: false,
    styleInput: {
      width: "350px",
    },
  },
  //   TTOAN_LPHI_OBJ: {
  //     field: "ttoan_lphi_obj",
  //     fieldReal: "ttoan_lphi",
  //     type: "field_array",
  //     list: {
  //       TLPHI: {
  //         field: "ttoan_tlphi", // Tên loại phí
  //         fieldReal: "TLPhi",
  //         type: "text",
  //         max: 100,
  //       },
  //       TPHI: {
  //         field: "ttoan_tphi", // Tiền thuế
  //         fieldReal: "TPhi",
  //         type: "number",
  //         max: 21,
  //       },
  //     },
  //   },
  TTOAN_TTCKTMAI: {
    field: "ttoan_ttcktmai", // Tổng tiền chiết khấu thương mại
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    disabled: true,
    widthLabel: "fit-content",
    required: false,
    max: 21,
    styleInput: {
      width: "350px",
    },
  },
  TTOAN_TGTTTBSO: {
    field: "ttoan_tgtttbso", // Tổng tiền thanh toán bằng số
    type: "number",
    isThousandSeparator: true,
    allowNegative: true,
    disabled: true,
    widthLabel: "fit-content",
    max: 21,
    required: false,
    styleInput: {
      width: "350px",
    },
  },
  TTOAN_TGTTTBCHU: {
    field: "ttoan_tgtttbchu", // Tổng tiền thanh toán bằng chữ
    type: "text",
    disabled: false,
    widthLabel: "fit-content",
    max: 255,
    required: false,
    isShowLabel: false,
    styleInput: {
      width: "350px",
      fontWeight: "bold",
    },
  },
  TTOAN_TTKHAC_OBJ: {
    field: "ttoan_ttkhac", // Thanh toán khác
    type: "text",
    isHide: true,
    max: 255,
    required: false,
  },
};

export const TYPE_INVOICE_ANOTHER = {
  INVOICE_TICKETS: "INVOICE_TICKETS",
  DELIVERY_BILL: "DELIVERY_BILL",
  WAREHOUSE_AGENCY: "WAREHOUSE_AGENCY",
  INVOICE_TOTAL: "INVOICE_TOTAL",
  ERROR_TCT: "ERROR_TCT", // hóa đơn treo
  ERROR_DELIVERY_BILL_TCT: "ERROR_DELIVERY_BILL_TCT", // Phiếu xuất kho vc nội bộ treo
  ERROR_WAREHOUSE_AGENCY_TCT: "ERROR_WAREHOUSE_AGENCY_TCT", // Phiếu xuất kho gửi bán đại lý
  DASHBOARDS_INVOICE_RECENTLY: "DASHBOARDS_INVOICE_RECENTLY", //
};

export const MODE_INVOICE_ACTION = {
  REPLACE: "REPLACE",
  ADJUST: "ADJUST",
};

export const TYPE_ADJUST_INVOICE = {
  INCREASE: 1,
  DECREASE: 2,
  CHANGE_INFO: 3,
};

export const TYPE_REPORT_WORD = {
  ADJUST: "adjust",
  CANCEL: "cancel",
  INFO: "info",
  GRA: "gra",
  // Hóa đơn MTT điều chỉnh thông tin bằng cách thay thế hóa đơn: nội dung biên
  // bản y hệt INFO, chỉ khác type gửi lên API
  INFO_CANCEL: "info_cancel",
};

export const TYPE_ACTION_WORKFLOW = {
  SUBMIT: "SUBMIT",
  APPROVE: "APPROVE",
  REJECT: "REJECT",
};

// $link_type Đánh dấu trạng thái liên kết điều chỉnh/thay thế 1 => parent replace , 2 => parent adjust , 3 => child replace , 4 => child adjust
export const LINK_TYPE = {
  NORMAL: "NULL",
  PARENT_REPLACE: 1,
  PARENT_ADJUST: 2,
  CHILD_REPLACE: 3,
  CHILD_ADJUST: 4,
  CHILD_REPLACE_TT32: 5,
  CHILD_ADJUST_TT32: 6,
};

export const TYPE_LINKS_MAP = {
  TYPE_ADJUST_INCREMENT: 1,
  TYPE_ADJUST_DECREMENT: 2,
  TYPE_ADJUST_INFO: 3,
  TYPE_REPLACE: 4,
  TYPE_REPLACE_TT32: 5,
  TYPE_ADJUST_TT32: 6,
};

export const TYPE_CLONE = {
  REPLACE_NEW: 1,
  ADJUST_DECREMENT_100: 2,
};

export const TTHDLQUAN_TCHDON = {
  REPLACE: "1",
  ADJUST: "2",
};

export const optionsVAT = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 5,
    label: "5%",
  },
  {
    value: 8,
    label: "8%",
  },
  {
    value: 10,
    label: "10%",
  },
  {
    value: 0,
    label: "KCT",
  },
  {
    value: 0,
    label: "KKKNT",
  },
];

export const FIELD_DISABLE_CONFIG = {
  hhdv_obj: {
    tchat: true,
    mhhdvu: true,
    thhdvu: true,
    dvtinh: false,
    sluong: true,
    dgia: true,
    tlckhau: true,
    stckhau: true,
    tsuat: true,
    thtien: true,
  },
};

export const DEFAULT_NULL_NUMBER = null;
export const TCHAT_VALUES = {
  GOODS: "1", // hàng hóa dịch vụ
  PROMOTION: "2", // khuyến mãi
  DISCOUNT: "3", // chiết khấu thương mại
  EXPLAIN: "4", // Ghi chú diễn giải
  SPECIALIZATION_GOODS: "5", // Hàng hóa đặc trưng
};
